import {
  MULTIPLE_DOMAIN_SCAN_REQUEST,
  MULTIPLE_DOMAIN_SCAN_SUCCESS,
  MULTIPLE_DOMAIN_SCAN_FAILURE,
  MULTIPLE_DOMAIN_SCAN_RESET
} from '../constants/multipleDomainConstants';

const initialState = {
  loading: false,
  data: null,
  error: null,
  success: false
};

const multipleDomainReducer = (state = initialState, action) => {
  switch (action.type) {
    case MULTIPLE_DOMAIN_SCAN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case MULTIPLE_DOMAIN_SCAN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
        success: true
      };
    case MULTIPLE_DOMAIN_SCAN_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
        success: false
      };
    case MULTIPLE_DOMAIN_SCAN_RESET:
      return initialState;
    default:
      return state;
  }
};

export default multipleDomainReducer;